export const LIVE_SYSTEMS = [
  { key: "crm", name: "CRM" },
  { key: "trading", name: "Trading Platform" },
  { key: "payments", name: "Payment Gateway" },
  { key: "kyc", name: "KYC Provider" },
  { key: "whatsapp", name: "WhatsApp" },
  { key: "email", name: "Email" },
];

export const METRICS_META = [
  { key: "assistedRevenue", label: "Assisted FTD Revenue (EUR)", money: true },
  { key: "assistedCount", label: "Assisted FTD Count" },
  { key: "kyc", label: "KYC Progressions" },
  { key: "reengaged", label: "Re-engaged Clients" },
  { key: "escalations", label: "Open Human Escalations" },
  { key: "organic", label: "Organic Outcomes" },
  { key: "suppressed", label: "Suppressed Actions" },
];

export const AMBIENT_EVENTS = [
  { system: "CRM", text: "New lead received — campaign EU-Q3", amount: null },
  { system: "Trading Platform", text: "Client login — MT5 mobile", amount: null },
  { system: "Payment Gateway", text: "Deposit settled", amount: "€1,200" },
  { system: "KYC Provider", text: "Identity check passed", amount: null },
  { system: "Email", text: "Statement email opened", amount: null },
  { system: "Trading Platform", text: "Position closed — EURUSD", amount: "+€214" },
  { system: "Payment Gateway", text: "Withdrawal settled by payments team", amount: "€3,100" },
  { system: "WhatsApp", text: "Client reply received", amount: null },
  { system: "CRM", text: "Task completed by account manager", amount: null },
  { system: "KYC Provider", text: "Document uploaded for review", amount: null },
];

export const FEED_SCRIPT = [
  { t: "14:03:11", type: "REGISTRATION", client: "Maria Rossi", detail: "CRM" },
  { t: "14:11:34", type: "PAYMENT FAILED", client: "Maria Rossi", detail: "€2,500 · 3DS abandoned" },
  { t: "14:11:37", type: "RECOVERY SENT", client: "Maria Rossi", detail: "WhatsApp · Italian" },
  { t: "14:13:40", type: "PAYMENT RETRY", client: "Maria Rossi", detail: "deposit page reopened" },
  { t: "14:14:13", type: "FTD CONFIRMED", client: "Maria Rossi", detail: "€2,500 · Assisted", effect: { metric: "assistedFtd", amount: 2500, caseId: "ftd" } },
  { t: "14:14:31", type: "KYC DOCUMENT UPLOADED", client: "Sofia Martinez", detail: "proof of address", effect: { metric: "kyc", caseId: "kyc" } },
  { t: "14:15:03", type: "HUMAN ESCALATION", client: "Ahmed Al-Mansoori", detail: "Compliance · SLA 15m", effect: { metric: "escalation", caseId: "compliance" } },
  { t: "14:15:22", type: "RE-ENGAGEMENT", client: "Luca Bianchi", detail: "platform login detected", effect: { metric: "reengaged", caseId: "retention" } },
  { t: "14:16:08", type: "COMMUNICATION BLOCKED", client: "Emma Johnson", detail: "suppression rule", effect: { metric: "suppressed", caseId: "suppressed" } },
  { t: "14:16:44", type: "FUNDING INITIATED", client: "Daniel Weber", detail: "€1,000 · in progress", effect: { caseId: "nudge" } },
  { t: "14:17:02", type: "HUMAN ESCALATION", client: "James Carter", detail: "Payments support · SLA 10m", effect: { metric: "escalation", caseId: "payments-esc" } },
  { t: "14:17:30", type: "WITHDRAWAL STATUS SENT", client: "Carlos Mendes", detail: "Portuguese · status-only" },
  { t: "14:18:12", type: "ORGANIC FTD", client: "Thomas Evans", detail: "£3,000 · no intervention", effect: { metric: "organic", caseId: "organic" } },
  { t: "14:18:40", type: "HUMAN ESCALATION", client: "Michael Chen", detail: "Retention team · SLA 30m", effect: { metric: "escalation", caseId: "hv-esc" } },
  { t: "14:19:05", type: "NO ACTION", client: "Chloe Martin", detail: "progressing normally" },
];

const WD_BOUNDARY = [
  "Approve withdrawals", "Reject withdrawals", "Delay withdrawals",
  "Block withdrawals", "Change withdrawal status", "Influence withdrawal decisions",
];

export const LIVE_SCENARIOS = [
  {
    id: "ftd", category: "FTD",
    boardFrom: "FTD At Risk", boardTo: "FTD Confirmed",
    client: { name: "Maria Rossi", ref: "SIM-2201", country: "Italy", language: "Italian", jurisdiction: "EU entity — CySEC", value: "€2,500", segment: "New retail" },
    condition: { label: "FTD At Risk", severity: "High", timeInState: "11 minutes" },
    attribution: "Assisted",
    metric: { metric: "assistedFtd", amount: 2500 },
    event: { t: "14:11:34", type: "Deposit Attempt Failed", source: "Payment Gateway", amount: "€2,500" },
    stateTransition: { from: "Registered → Funding", to: "Funding Failure" },
    classification: "FTD AT RISK",
    why: [
      "Registration completed at 14:03",
      "€2,500 deposit attempt detected",
      "Deposit not confirmed",
      "3DS authentication abandoned",
      "No previous funding recovery communication",
      "Consent on file: WhatsApp ✓ · Email ✓",
    ],
    policy: { blocked: false, checks: [
      "Communication permitted",
      "Client opted in",
      "Frequency cap clear",
      "Entity rules passed (EU book)",
      "Approved funding recovery template available (FTD-RECOVERY-02)",
      "Account status eligible",
      "Regulatory restrictions checked",
    ] },
    decision: {
      type: "AUTOMATED FUNDING RECOVERY", workflow: "Immediate Funding Recovery", priority: "High", confidence: "94%",
      reason: "Recoverable payment abandonment — 3DS abandoned, not issuer decline",
      channel: "WhatsApp", language: "Italian",
    },
    action: {
      kind: "automated", channel: "WhatsApp", language: "Italian", template: "FTD-RECOVERY-02", t: "14:11:37",
      message: "Ciao Maria, abbiamo notato che il tuo tentativo di deposito da €2.500 non è stato completato durante la verifica 3-D Secure. Nessun importo è stato addebitato. Puoi riprendere esattamente da dove hai interrotto qui: [secure-link] — il tuo conto è pronto. (Simulated message — synthetic data)",
      delivery: ["Sent", "Delivered", "Opened"],
    },
    response: [
      { t: "14:13:40", text: "Client payment retry detected", system: "Payment Gateway", phase: "response" },
      { t: "14:14:12", text: "€2,500 FTD confirmed", system: "Payment Gateway", phase: "response" },
    ],
    stateFinal: { from: "Funding Failure", to: "FTD Confirmed" },
    outcome: {
      title: "FTD Recovered", value: "€2,500", intervention: "WhatsApp Funding Recovery",
      language: "Italian", time: "2m 38s", classification: "ASSISTED FTD",
      crm: "Updated", attribution: "Assisted — O.N.E.Tech intervention preceded the outcome",
    },
    flow: ["Payment Gateway", "O.N.E.Tech Intelligence", "Policy Engine", "WhatsApp", "CRM"],
    timeline: [
      { t: "14:03:11", text: "Registration received from CRM", system: "CRM", phase: "event" },
      { t: "14:06:24", text: "Platform login detected", system: "Trading Platform", phase: "event" },
      { t: "14:11:08", text: "Deposit initiated — €2,500", system: "Payment Gateway", phase: "event" },
      { t: "14:11:34", text: "Payment failure received — 3DS authentication abandoned", system: "Payment Gateway", phase: "event" },
      { t: "14:11:35", text: "Client state updated to Funding Failure", system: "O.N.E.Tech", phase: "state" },
      { t: "14:11:35", text: "Policy check initiated — communication eligible (7/7)", system: "Policy Engine", phase: "policy" },
      { t: "14:11:36", text: "Decision: Immediate Funding Recovery — priority High, confidence 94%", system: "O.N.E.Tech", phase: "decision" },
      { t: "14:11:37", text: "Italian WhatsApp recovery triggered (template FTD-RECOVERY-02)", system: "WhatsApp", phase: "action" },
      { t: "14:12:02", text: "Message delivered · opened", system: "WhatsApp", phase: "action" },
      { t: "14:13:40", text: "Client payment retry detected", system: "Payment Gateway", phase: "response" },
      { t: "14:14:12", text: "€2,500 FTD confirmed", system: "Payment Gateway", phase: "update" },
      { t: "14:14:13", text: "CRM updated — lifecycle Funding Failure → FTD Confirmed", system: "CRM", phase: "update" },
      { t: "14:14:13", text: "Assisted FTD attribution recorded — €2,500", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "nudge", category: "FTD",
    boardFrom: "Registered", boardTo: "Funding In Progress",
    client: { name: "Daniel Weber", ref: "SIM-2202", country: "Germany", language: "German", jurisdiction: "EU entity — BaFin", value: "—", segment: "New retail" },
    condition: { label: "FTD Opportunity", severity: "Medium", timeInState: "27 minutes" },
    attribution: "Assisted",
    metric: null,
    event: { t: "09:31:47", type: "Platform Login — No Deposit Initiated", source: "Trading Platform", amount: null },
    stateTransition: { from: "Registered", to: "Registered — No FTD" },
    classification: "FTD OPPORTUNITY",
    why: [
      "Registration completed 27 minutes ago",
      "Client logged into the platform",
      "No deposit initiated",
      "No sales contact recorded",
      "Funding window still active",
      "Welcome email opened earlier",
    ],
    policy: { blocked: false, checks: [
      "Communication permitted",
      "Client opted in",
      "Frequency cap clear",
      "Entity rules passed (EU book)",
      "Approved onboarding template available (FTD-NUDGE-01)",
      "Account status eligible",
      "Regulatory restrictions checked",
    ] },
    decision: {
      type: "AUTOMATED NUDGE", workflow: "Personalised Funding Nudge", priority: "Medium", confidence: "87%",
      reason: "Engaged registrant inside the funding window with zero outreach so far",
      channel: "Email", language: "German",
    },
    action: {
      kind: "automated", channel: "Email", language: "German", template: "FTD-NUDGE-01", t: "09:31:49",
      message: "(DE) Hallo Daniel — willkommen an Bord. Ihr Konto ist eingerichtet und Sie waren bereits auf der Plattform aktiv. Wenn Sie bereit sind: Ihre erste Einzahlung dauert unter 2 Minuten — [funding-link]. Bei Fragen antworten Sie einfach auf diese E-Mail. (Simulated message — synthetic data)",
      delivery: ["Sent", "Delivered", "Opened"],
    },
    response: [
      { t: "09:33:02", text: "Email opened — funding link clicked", system: "Email", phase: "response" },
      { t: "09:34:15", text: "Deposit initiated — €1,000", system: "Payment Gateway", phase: "response" },
    ],
    stateFinal: { from: "Registered — No FTD", to: "Funding In Progress" },
    outcome: {
      title: "Funding Initiated", value: "€1,000 in progress", intervention: "German funding nudge email",
      language: "German", time: "2m 28s", classification: "ASSISTED — IN PROGRESS",
      crm: "Updated", attribution: "Assisted — FTD not yet confirmed; counted only on confirmation",
    },
    flow: ["Trading Platform", "O.N.E.Tech Intelligence", "Policy Engine", "Email", "CRM"],
    timeline: [
      { t: "09:04:47", text: "Registration received from CRM", system: "CRM", phase: "event" },
      { t: "09:12:30", text: "Welcome email opened", system: "Email", phase: "event" },
      { t: "09:31:47", text: "Platform login — no deposit initiated", system: "Trading Platform", phase: "event" },
      { t: "09:31:48", text: "Client state: Registered — No FTD (FTD opportunity)", system: "O.N.E.Tech", phase: "state" },
      { t: "09:31:48", text: "Policy check passed (7/7)", system: "Policy Engine", phase: "policy" },
      { t: "09:31:49", text: "Decision: Personalised Funding Nudge — priority Medium", system: "O.N.E.Tech", phase: "decision" },
      { t: "09:31:49", text: "German funding nudge email triggered (FTD-NUDGE-01)", system: "Email", phase: "action" },
      { t: "09:31:54", text: "Message delivered", system: "Email", phase: "action" },
      { t: "09:33:02", text: "Email opened — funding link clicked", system: "Email", phase: "response" },
      { t: "09:34:15", text: "Deposit initiated — €1,000", system: "Payment Gateway", phase: "update" },
      { t: "09:34:16", text: "CRM updated — lifecycle Registered → Funding In Progress", system: "CRM", phase: "update" },
      { t: "09:34:16", text: "Assisted attribution (in progress) — counts on FTD confirmation only", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "payments-esc", category: "FTD",
    boardFrom: "Funding Failure", boardTo: "FTD Confirmed (Agent)",
    client: { name: "James Carter", ref: "SIM-2203", country: "United Kingdom", language: "English", jurisdiction: "UK entity", value: "£8,000", segment: "Standard retail" },
    condition: { label: "Repeated Funding Failure", severity: "High", timeInState: "3 attempts over 2 days" },
    attribution: "Human Assisted",
    metric: null,
    event: { t: "11:52:09", type: "Deposit Failed — 3rd Consecutive Attempt", source: "Payment Gateway", amount: "£8,000" },
    stateTransition: { from: "Funding", to: "Repeated Funding Failure" },
    classification: "REPEATED FUNDING FAILURE",
    why: [
      "Three unsuccessful deposit attempts (£8,000)",
      "Automated recovery already attempted twice",
      "Client opened both automated communications",
      "No successful deposit event",
      "Further automation would loop without new information",
    ],
    policy: { blocked: true, blockReason: "Automation limit reached — repeated failures require human support. Automation does not loop endlessly.", checks: [
      "Communication permitted",
      "Client opted in",
      "Frequency cap — automated recovery limit reached (2/2)",
      "Entity rules passed (UK book)",
      "Approved template available — suppressed by automation limit",
      "Account status eligible",
      "Regulatory restrictions checked",
    ] },
    decision: {
      type: "HUMAN ESCALATION REQUIRED", workflow: "Payments Support Routing", priority: "High", confidence: "96%",
      reason: "Repeated failure after two automated attempts — human review of gateway failure context",
      channel: "—", language: "—",
    },
    action: {
      kind: "human",
      task: {
        assignee: "Payments / Client Support", priority: "High", slaMinutes: 10,
        context: [
          "Lifecycle stage: Funding — repeated failure",
          "Deposit attempts: 3 × £8,000 — all failed",
          "Gateway failure context attached (3DS + issuer codes)",
          "Automated recovery: 2 attempts, both opened",
          "Previous communication: onboarding + recovery x2",
          "Recommended next action: review gateway failure context and contact client",
        ],
      },
    },
    slaStopAt: 0.25,
    response: [
      { t: "11:57:48", text: "Support agent accepted the task — within SLA", system: "CRM", phase: "response" },
      { t: "12:03:22", text: "Agent called client — card issuer block identified", system: "VoIP", phase: "response" },
      { t: "12:09:41", text: "Bank transfer completed — £8,000 settled", system: "Payment Gateway", phase: "response" },
    ],
    stateFinal: { from: "Repeated Funding Failure", to: "FTD Confirmed (Agent-Assisted)" },
    outcome: {
      title: "FTD Recovered by Human", value: "£8,000", intervention: "Payments support call → bank transfer",
      language: "English", time: "17m 32s", classification: "HUMAN ASSISTED FTD",
      crm: "Updated", attribution: "Human Assisted — O.N.E.Tech identified and routed; the agent completed the recovery",
    },
    flow: ["Payment Gateway", "O.N.E.Tech Intelligence", "Policy Engine", "CRM Task", "Payments / Support"],
    timeline: [
      { t: "11:52:09", text: "Deposit failed — 3rd consecutive attempt (£8,000)", system: "Payment Gateway", phase: "event" },
      { t: "11:52:10", text: "Client state updated to Repeated Funding Failure", system: "O.N.E.Tech", phase: "state" },
      { t: "11:52:10", text: "Policy check: automation limit reached (2/2) — further automation suppressed", system: "Policy Engine", phase: "policy" },
      { t: "11:52:11", text: "Decision: Human Escalation Required — Payments Support Routing", system: "O.N.E.Tech", phase: "decision" },
      { t: "11:52:12", text: "CRM task created → Payments / Client Support · priority High · SLA 10:00 · gateway context attached", system: "CRM", phase: "action" },
      { t: "11:57:48", text: "Support agent accepted the task — within SLA", system: "CRM", phase: "response" },
      { t: "12:03:22", text: "Agent called client — card issuer block identified", system: "VoIP", phase: "response" },
      { t: "12:09:41", text: "Bank transfer completed — £8,000 settled", system: "Payment Gateway", phase: "update" },
      { t: "12:09:42", text: "CRM updated — lifecycle → FTD Confirmed (Agent-Assisted)", system: "CRM", phase: "update" },
      { t: "12:09:42", text: "Attribution: Human Assisted FTD — £8,000", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "kyc", category: "KYC",
    boardFrom: "KYC Stalled", boardTo: "KYC Review Pending",
    client: { name: "Sofia Martinez", ref: "SIM-2204", country: "Spain", language: "Spanish", jurisdiction: "EU entity — CySEC", value: "—", segment: "New retail" },
    condition: { label: "KYC Progression Stalled", severity: "Medium", timeInState: "19 hours" },
    attribution: "Assisted",
    metric: { metric: "kyc" },
    event: { t: "08:14:52", type: "KYC Inactive — 19 Hours", source: "KYC Provider", amount: null },
    stateTransition: { from: "KYC In Progress", to: "KYC Progression Stalled" },
    classification: "KYC PROGRESSION STALLED",
    why: [
      "KYC initiated",
      "Identity document accepted",
      "Proof of address missing",
      "No activity for 19 hours",
      "Status remains incomplete",
      "Consent on file: Email ✓ · WhatsApp ✓",
    ],
    policy: { blocked: false, checks: [
      "Communication permitted",
      "Client opted in",
      "Frequency cap clear",
      "Entity rules passed (EU book)",
      "Broker-approved KYC status codes only — no interpretation of the KYC decision",
      "Approved reminder template available (KYC-REMINDER-01)",
      "Regulatory restrictions checked",
    ] },
    decision: {
      type: "APPROVED KYC REMINDER", workflow: "KYC Completion Reminder", priority: "Medium", confidence: "90%",
      reason: "Single missing document with a 19-hour stall — reminder returns the client to the verification journey",
      channel: "Email", language: "Spanish",
    },
    action: {
      kind: "automated", channel: "Email", language: "Spanish", template: "KYC-REMINDER-01", t: "08:14:54",
      message: "(ES) Hola Sofía — tu verificación está casi lista; solo queda un documento por completar. Puedes continuar tu verificación desde tu móvil aquí: [kyc-link]. (Simulated message — synthetic data)",
      delivery: ["Sent", "Delivered", "Opened"],
    },
    response: [
      { t: "08:16:03", text: "Email opened — KYC link clicked", system: "Email", phase: "response" },
      { t: "08:17:44", text: "Proof of address uploaded", system: "KYC Provider", phase: "response" },
    ],
    stateFinal: { from: "KYC Progression Stalled", to: "KYC Review Pending" },
    outcome: {
      title: "KYC Progressed", value: "Verification resumed", intervention: "Spanish KYC reminder",
      language: "Spanish", time: "2m 52s", classification: "ASSISTED KYC PROGRESSION",
      crm: "Updated", attribution: "Assisted — KYC approval itself remains with Compliance; O.N.E.Tech does not approve KYC",
    },
    flow: ["KYC Provider", "O.N.E.Tech Intelligence", "Policy Engine", "Email", "CRM"],
    timeline: [
      { t: "08:14:52", text: "KYC inactive for 19 hours — proof of address missing", system: "KYC Provider", phase: "event" },
      { t: "08:14:53", text: "Client state: KYC Progression Stalled", system: "O.N.E.Tech", phase: "state" },
      { t: "08:14:53", text: "Policy check passed — broker-approved status codes and templates only", system: "Policy Engine", phase: "policy" },
      { t: "08:14:54", text: "Decision: Approved KYC Reminder — priority Medium", system: "O.N.E.Tech", phase: "decision" },
      { t: "08:14:54", text: "Spanish reminder triggered (KYC-REMINDER-01)", system: "Email", phase: "action" },
      { t: "08:14:59", text: "Message delivered", system: "Email", phase: "action" },
      { t: "08:16:03", text: "Email opened — KYC link clicked", system: "Email", phase: "response" },
      { t: "08:17:44", text: "Proof of address uploaded", system: "KYC Provider", phase: "response" },
      { t: "08:17:45", text: "Lifecycle updated: KYC Stalled → KYC Review Pending · CRM updated", system: "CRM", phase: "update" },
      { t: "08:17:45", text: "Assisted KYC progression attributed — approval remains with Compliance", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "compliance", category: "Escalation",
    boardFrom: "Compliance Hold", boardTo: "Review Completed",
    client: { name: "Ahmed Al-Mansoori", ref: "SIM-2246", country: "United Arab Emirates", language: "Arabic", jurisdiction: "UAE entity — DFSA", value: "$25,000 intended funding", segment: "High Value" },
    condition: { label: "Sensitive KYC State", severity: "Critical", timeInState: "Since 10:05" },
    attribution: "Human Assisted",
    metric: { metric: "escalation" },
    slaBreach: true,
    event: { t: "10:05:33", type: "High-Value Deposit Initiated — KYC Flag", source: "KYC Provider", amount: "$25,000" },
    stateTransition: { from: "Funding", to: "Compliance Hold" },
    classification: "HIGH-VALUE — SENSITIVE COMPLIANCE CONDITION",
    why: [
      "Deposit initiated: $25,000",
      "KYC: Additional Review Required",
      "Client classification: High Value",
      "No approved template for sensitive compliance status",
      "Automation eligibility rule failed — human review mandatory",
    ],
    policy: { blocked: true, blockReason: "Sensitive compliance status requiring authorised human review. No automated explanation is sent to the client.", checks: [
      "Communication permitted",
      "Client opted in",
      "Frequency cap clear",
      "Entity rules passed (UAE book)",
      "Approved template — FAILED: no template for sensitive compliance status",
      "Account status eligible — FAILED: KYC Additional Review Required",
      "Regulatory restrictions checked",
    ] },
    decision: {
      type: "HUMAN ESCALATION", workflow: "Compliance Review Routing", priority: "Critical", confidence: "99%",
      reason: "Automation blocked by policy — routing to authorised compliance reviewer with full context",
      channel: "—", language: "—",
    },
    action: {
      kind: "human",
      task: {
        assignee: "Compliance Team", priority: "Critical / High", slaMinutes: 15,
        context: [
          "KYC status: Additional Review Required",
          "Client language: Arabic",
          "Intended deposit: $25,000",
          "Previous communications: onboarding completed, no flags",
          "Account entity: UAE — DFSA",
          "Lifecycle stage: Funding → Compliance Hold",
        ],
      },
    },
    response: [
      { t: "10:19:46", text: "SLA exceeded — 15:00 elapsed without compliance action", system: "O.N.E.Tech", phase: "response", breach: true },
      { t: "10:19:46", text: "SLA BREACH → Team Lead escalation triggered", system: "CRM", phase: "response", breach: true },
      { t: "10:24:02", text: "Compliance Team Lead accepted the review", system: "CRM", phase: "response", breach: true },
      { t: "10:31:47", text: "Review completed — account cleared by Compliance", system: "KYC Provider", phase: "response", breach: true },
      { t: "10:31:48", text: "Lifecycle updated: Compliance Hold → Review Completed · CRM write-back", system: "CRM", phase: "update", breach: true },
      { t: "10:31:48", text: "Attribution: Human Assisted — routed by O.N.E.Tech, resolved by Compliance", system: "O.N.E.Tech", phase: "outcome", breach: true },
    ],
    stateFinal: { from: "Compliance Hold", to: "Review Completed" },
    outcome: {
      title: "Cleared by Compliance", value: "$25,000 deposit processed", intervention: "Compliance routing + SLA-breach escalation",
      language: "—", time: "26m 14s", classification: "HUMAN ASSISTED — COMPLIANCE",
      crm: "Updated", attribution: "Human Assisted — O.N.E.Tech identified, routed and enforced the SLA; humans decided",
    },
    flow: ["KYC Provider", "O.N.E.Tech Intelligence", "Policy Engine", "CRM Task", "Compliance Team"],
    timeline: [
      { t: "10:05:33", text: "$25,000 deposit initiated — KYC flag: Additional Review Required", system: "KYC Provider", phase: "event" },
      { t: "10:05:33", text: "Client classified: Compliance Hold — sensitive condition", system: "O.N.E.Tech", phase: "state" },
      { t: "10:05:34", text: "Policy & eligibility check: 2 rules FAILED — AUTOMATION BLOCKED", system: "Policy Engine", phase: "policy" },
      { t: "10:05:34", text: "Decision: Human Escalation — Compliance Review Routing, priority Critical", system: "O.N.E.Tech", phase: "decision" },
      { t: "10:05:35", text: "CRM task created → Compliance Team · priority High · SLA 15:00 · full context attached", system: "CRM", phase: "action" },
    ],
  },
  {
    id: "healthy", category: "Healthy",
    boardFrom: "Active Funded", boardTo: "Active Funded",
    client: { name: "Chloe Martin", ref: "SIM-2206", country: "France", language: "French", jurisdiction: "EU entity — AMF", value: "€4,000", segment: "Standard retail" },
    condition: { label: "None — healthy", severity: "None", timeInState: "—" },
    attribution: "Excluded",
    metric: null,
    event: { t: "10:22:18", type: "Routine Activity Scan", source: "Trading Platform", amount: null },
    stateTransition: { from: "Active Funded", to: "Active Funded" },
    classification: "ACTIVE FUNDED — HEALTHY",
    why: [
      "FTD €4,000 confirmed",
      "KYC verified",
      "Platform login today",
      "Recent activity within normal band",
      "No risk or opportunity signals detected",
    ],
    policy: { blocked: false, checks: [
      "No intervention criteria met",
      "Communication frequency preserved for meaningful events",
      "No suppression rule active",
      "Account status healthy",
    ] },
    decision: {
      type: "NO ACTION REQUIRED", workflow: "Observation only", priority: "—", confidence: "98%",
      reason: "Client progressing normally — no communication sent",
      channel: "—", language: "—",
    },
    action: { kind: "none", noneReason: "Client progressing normally. O.N.E.Tech does not contact clients without an operational reason — restraint is part of the operating model." },
    response: [],
    stateFinal: { from: "Active Funded", to: "Active Funded" },
    outcome: {
      title: "No Intervention", value: "—", intervention: "None",
      language: "—", time: "—", classification: "EXCLUDED — HEALTHY PROGRESSION",
      crm: "No change", attribution: "Excluded — no O.N.E.Tech involvement",
    },
    flow: ["Trading Platform", "O.N.E.Tech Intelligence", "Policy Engine", "—", "CRM"],
    timeline: [
      { t: "10:22:18", text: "Routine activity scan — login today, normal band", system: "Trading Platform", phase: "event" },
      { t: "10:22:18", text: "State confirmed: Active Funded — no change", system: "O.N.E.Tech", phase: "state" },
      { t: "10:22:19", text: "Policy review: no intervention criteria met", system: "Policy Engine", phase: "policy" },
      { t: "10:22:19", text: "Decision: NO ACTION REQUIRED — observation only", system: "O.N.E.Tech", phase: "decision" },
      { t: "10:22:19", text: "No action taken — client left undisturbed", system: "O.N.E.Tech", phase: "action" },
      { t: "10:22:19", text: "Attribution: Excluded — healthy progression", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "retention", category: "Retention",
    boardFrom: "Retention Risk", boardTo: "Re-engaged",
    client: { name: "Luca Bianchi", ref: "SIM-2207", country: "Italy", language: "Italian", jurisdiction: "EU entity — CySEC", value: "€18,400 funded", segment: "High engagement" },
    condition: { label: "Retention Risk — High", severity: "High", timeInState: "9 days declining" },
    attribution: "Assisted",
    metric: { metric: "reengaged" },
    event: { t: "07:15:40", type: "Deposit Frequency Decline Detected", source: "Trading Platform", amount: "€18,400 funded" },
    stateTransition: { from: "Active Funded", to: "Engagement Decline" },
    classification: "RETENTION RISK — HIGH",
    why: [
      "Login frequency materially decreased — no login for 9 days",
      "Deposit frequency down 71% over 21 days",
      "Previous activity: 4 sessions/week",
      "No active support issue explaining inactivity",
      "Previously high-engagement client",
      "Funded account remains active (€18,400)",
    ],
    policy: { blocked: false, checks: [
      "Communication eligible",
      "Client opted in",
      "Retention template approved (RET-REENGAGE-03)",
      "No frequency restriction",
      "Account status permitted",
      "Early-warning rule (RET-01): before 30-day dormancy threshold",
    ] },
    decision: {
      type: "PERSONALISED RE-ENGAGEMENT", workflow: "Pre-Dormancy Save Play", priority: "High", confidence: "89%",
      reason: "Compound decline signals on a previously high-engagement funded account",
      channel: "WhatsApp", language: "Italian",
    },
    action: {
      kind: "automated", channel: "WhatsApp", language: "Italian", template: "RET-REENGAGE-03", t: "07:15:41",
      message: "Ciao Luca — nelle ultime due settimane non hai effettuato l'accesso. Il tuo conto (€18.400) è attivo e questa settimana ci sono stati movimenti sui mercati della tua watchlist. Se ti serve qualcosa, rispondi qui: il team è a disposizione. (Simulated message — synthetic data)",
      delivery: ["Sent", "Delivered", "Opened"],
    },
    response: [
      { t: "11:03:12", text: "Message opened", system: "WhatsApp", phase: "response" },
      { t: "11:04:47", text: "Client logged into trading platform — session 22 minutes", system: "Trading Platform", phase: "response" },
    ],
    stateFinal: { from: "Engagement Decline", to: "Re-engaged" },
    outcome: {
      title: "Client Re-engaged", value: "€18,400 retained", intervention: "Italian WhatsApp re-engagement",
      language: "Italian", time: "3h 49m", classification: "ASSISTED RE-ENGAGEMENT",
      crm: "Updated", attribution: "Assisted — re-engagement message preceded the login",
    },
    flow: ["Trading Platform", "O.N.E.Tech Intelligence", "Policy Engine", "WhatsApp", "CRM"],
    timeline: [
      { t: "07:15:40", text: "Deposit frequency decline detected — down 71% over 21 days", system: "Trading Platform", phase: "event" },
      { t: "07:15:40", text: "Client classified: Engagement Decline (Retention Risk — High)", system: "O.N.E.Tech", phase: "state" },
      { t: "07:15:41", text: "Policy check passed (6/6) — RET-01 early-warning applied", system: "Policy Engine", phase: "policy" },
      { t: "07:15:41", text: "Decision: Personalised Re-engagement — priority High, confidence 89%", system: "O.N.E.Tech", phase: "decision" },
      { t: "07:15:41", text: "Italian WhatsApp re-engagement triggered (RET-REENGAGE-03)", system: "WhatsApp", phase: "action" },
      { t: "07:15:46", text: "Message delivered", system: "WhatsApp", phase: "action" },
      { t: "11:03:12", text: "Message opened", system: "WhatsApp", phase: "response" },
      { t: "11:04:47", text: "Client logged into trading platform — 22-minute session", system: "Trading Platform", phase: "response" },
      { t: "11:04:48", text: "Lifecycle updated: Engagement Decline → Re-engaged · CRM updated", system: "CRM", phase: "update" },
      { t: "11:04:48", text: "Assisted Re-engagement attributed — €18,400 retained", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "hv-esc", category: "Retention",
    boardFrom: "High-Value Dormancy", boardTo: "Re-engaged (RM)",
    client: { name: "Michael Chen", ref: "SIM-2208", country: "Singapore", language: "English", jurisdiction: "International entity", value: "$62,000 balance", segment: "High Value" },
    condition: { label: "High-Value Dormancy", severity: "Critical", timeInState: "14 days inactive" },
    attribution: "Human Assisted",
    metric: { metric: "escalation" },
    event: { t: "06:40:12", type: "Inactivity Threshold Crossed — 14 Days", source: "Trading Platform", amount: "$62,000 balance" },
    stateTransition: { from: "Active Funded", to: "High-Value Dormancy" },
    classification: "HIGH-VALUE DORMANCY",
    why: [
      "Account balance $62,000 — above simulated escalation threshold",
      "14 days of inactivity",
      "Historically high activity",
      "Previous automated retention communication delivered — no engagement",
      "No open support issue",
    ],
    policy: { blocked: true, blockReason: "Account value above the automated-action threshold — human relationship escalation required.", checks: [
      "Communication eligible",
      "Client opted in",
      "Retention template approved",
      "No frequency restriction",
      "Account value within auto-action threshold — FAILED: $62,000 exceeds the $50,000 limit",
      "Prior automated attempt already delivered without engagement",
    ] },
    decision: {
      type: "HUMAN RELATIONSHIP ESCALATION", workflow: "High-Value Retention Routing", priority: "High", confidence: "93%",
      reason: "High-value dormancy after an unengaged automated attempt — a person must own this relationship",
      channel: "—", language: "—",
    },
    action: {
      kind: "human",
      task: {
        assignee: "Relationship Manager — Retention Team", priority: "High", slaMinutes: 30,
        context: [
          "Client value: $62,000 balance",
          "Historical activity: high (4+ sessions/week)",
          "Last login: 14 days ago",
          "Last deposit: 21 days ago",
          "Previous automated communication: delivered, no engagement",
          "Recommended next action: personal call within business hours",
        ],
      },
    },
    slaStopAt: 0.3,
    response: [
      { t: "07:02:55", text: "Relationship Manager accepted the task — within SLA", system: "CRM", phase: "response" },
      { t: "07:18:30", text: "RM call completed — client cited travel; no concerns", system: "VoIP", phase: "response" },
      { t: "07:19:02", text: "Client logged in — watchlist reviewed", system: "Trading Platform", phase: "response" },
    ],
    stateFinal: { from: "High-Value Dormancy", to: "Re-engaged (RM)" },
    outcome: {
      title: "High-Value Client Re-engaged", value: "$62,000 retained", intervention: "RM personal call",
      language: "English", time: "38m 50s", classification: "HUMAN ASSISTED RETENTION",
      crm: "Updated", attribution: "Human Assisted — O.N.E.Tech detected and routed; the RM completed the intervention",
    },
    flow: ["Trading Platform", "O.N.E.Tech Intelligence", "Policy Engine", "CRM Task", "Retention Team"],
    timeline: [
      { t: "06:40:12", text: "Inactivity threshold crossed — 14 days, balance $62,000", system: "Trading Platform", phase: "event" },
      { t: "06:40:12", text: "Client classified: High-Value Dormancy", system: "O.N.E.Tech", phase: "state" },
      { t: "06:40:13", text: "Policy check: value threshold exceeded — automated action not permitted", system: "Policy Engine", phase: "policy" },
      { t: "06:40:13", text: "Decision: Human Relationship Escalation — priority High", system: "O.N.E.Tech", phase: "decision" },
      { t: "06:40:14", text: "CRM task created → Relationship Manager · priority High · SLA 30:00 · full context attached", system: "CRM", phase: "action" },
      { t: "07:02:55", text: "RM accepted the task — within SLA", system: "CRM", phase: "response" },
      { t: "07:18:30", text: "RM call completed — client cited travel; no concerns", system: "VoIP", phase: "response" },
      { t: "07:19:02", text: "Client logged in — watchlist reviewed", system: "Trading Platform", phase: "update" },
      { t: "07:19:03", text: "Lifecycle updated: High-Value Dormancy → Re-engaged (RM) · CRM updated", system: "CRM", phase: "update" },
      { t: "07:19:03", text: "Attribution: Human Assisted Retention — $62,000 retained", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "suppressed", category: "Suppression",
    boardFrom: "Funding Opportunity", boardTo: "Suppressed — No Contact",
    client: { name: "Emma Johnson", ref: "SIM-2209", country: "Australia", language: "English", jurisdiction: "International entity", value: "—", segment: "New retail" },
    condition: { label: "FTD Opportunity — Suppressed", severity: "—", timeInState: "3 days" },
    attribution: "Excluded",
    metric: { metric: "suppressed" },
    event: { t: "13:27:40", type: "FTD Opportunity Identified", source: "CRM", amount: null },
    stateTransition: { from: "Funding Opportunity", to: "Funding Opportunity — Suppressed" },
    classification: "FTD OPPORTUNITY — SUPPRESSION ACTIVE",
    why: [
      "Registration completed 3 days ago",
      "No deposit initiated — funding window active",
      "Marketing / operational messaging: opted out",
      "Suppression rules override revenue opportunities",
    ],
    policy: { blocked: true, blockReason: "COMMUNICATION SUPPRESSION ACTIVE — client communication preference prevents outreach. The preference is never overridden.", checks: [
      "Communication consent — FAILED: client opted out of marketing/operational messaging",
      "Entity rules passed",
      "Suppression registry checked — active opt-out found",
      "Suppression overrides revenue opportunity",
    ] },
    decision: {
      type: "NO ACTION — SUPPRESSION ACTIVE", workflow: "None", priority: "—", confidence: "100%",
      reason: "Client communication preference prevents outreach",
      channel: "—", language: "—",
    },
    action: { kind: "none", noneReason: "No communication sent. The client's opt-out preference overrides the FTD opportunity — suppression rules are absolute." },
    response: [],
    stateFinal: { from: "Funding Opportunity", to: "Suppressed — No Contact" },
    outcome: {
      title: "Suppression Respected", value: "Opportunity foregone", intervention: "None — by policy",
      language: "—", time: "—", classification: "EXCLUDED — SUPPRESSION",
      crm: "Preference logged", attribution: "Excluded — not eligible for attribution",
    },
    flow: ["CRM", "O.N.E.Tech Intelligence", "Policy Engine", "—", "CRM"],
    timeline: [
      { t: "13:27:40", text: "FTD opportunity identified — registered 3 days ago, no deposit", system: "CRM", phase: "event" },
      { t: "13:27:41", text: "Policy layer: COMMUNICATION SUPPRESSION ACTIVE (client opted out)", system: "Policy Engine", phase: "policy" },
      { t: "13:27:41", text: "Decision: NO ACTION — suppression overrides the opportunity", system: "O.N.E.Tech", phase: "decision" },
      { t: "13:27:41", text: "No communication sent — preference preserved", system: "O.N.E.Tech", phase: "action" },
      { t: "13:27:41", text: "Attribution: Excluded — suppression event logged to CRM", system: "CRM", phase: "outcome" },
    ],
  },
  {
    id: "withdrawal", category: "Withdrawal",
    boardFrom: "Withdrawal Pending", boardTo: "Withdrawal Completed",
    client: { name: "David Okafor", ref: "ONET-1110", country: "Nigeria", language: "English", jurisdiction: "International entity — FSA", value: "$26,800 lifetime", segment: "High Value" },
    condition: { label: "Withdrawal Journey — Sensitive", severity: "Critical", timeInState: "52 hours pending" },
    attribution: "Human Assisted",
    metric: null,
    policyBoundary: WD_BOUNDARY,
    event: { t: "16:02:11", type: "Withdrawal Support Event Received", source: "CRM", amount: "$8,400 pending" },
    stateTransition: { from: "Withdrawal Pending", to: "Withdrawal Support Event" },
    classification: "WITHDRAWAL JOURNEY — SENSITIVE",
    why: [
      "Withdrawal of $8,400 pending 52 hours",
      "Two client chase messages received — escalation tone",
      "Public-complaint language detected in sentiment scan",
      "Balance checked 5 times today",
      "High lifetime value: $26,800",
      "Rule WD-01 active: non-interference — status communication only",
    ],
    policy: { blocked: false, checks: [
      "Client communication consent",
      "Correct brokerage entity (International book)",
      "Communication frequency allowed",
      "Approved status-only template available (WD-STATUS-01)",
      "WD-01 non-interference: status updates and human escalation only",
      "Human approval required for withdrawal-related communication",
    ] },
    decision: {
      type: "HUMAN ESCALATION + APPROVED STATUS UPDATE", workflow: "Withdrawal Coordination", priority: "Critical", confidence: "97%",
      reason: "SLA breach with complaint risk on a high-value client — senior human ownership mandatory",
      channel: "WhatsApp", language: "English",
    },
    action: {
      kind: "automated", channel: "WhatsApp", language: "English", template: "WD-STATUS-01 (status-only)", t: "16:02:14",
      message: "Hi David — an update on your $8,400 withdrawal: it is in final payment review and scheduled for release by 14:00 UTC today. Priya Nair (Senior Payments) is personally overseeing it and is available directly at [direct-line]. No action is needed from you. (Simulated message — synthetic data)",
      delivery: ["Sent", "Delivered", "Opened"],
      task: { assignee: "Priya Nair — Senior Retention Officer", priority: "Critical", sla: "30 minutes" },
    },
    response: [
      { t: "16:03:55", text: "Client reply: 'Thank you for the update.' — sentiment recovered", system: "WhatsApp", phase: "response" },
      { t: "16:11:20", text: "Payments team released the withdrawal (human action — not O.N.E.Tech)", system: "Payment Gateway", phase: "response" },
      { t: "16:11:21", text: "Client confirmed receipt — no public complaint", system: "CRM", phase: "response" },
    ],
    stateFinal: { from: "Withdrawal Support Event", to: "Withdrawal Completed" },
    outcome: {
      title: "Client Retained Post-Withdrawal", value: "$26,800 relationship protected", intervention: "Approved status update + senior human coordination",
      language: "English", time: "9m 10s", classification: "HUMAN ASSISTED — COORDINATION",
      crm: "Updated", attribution: "Human Assisted — no revenue recovery attribution is claimed on withdrawal cases",
    },
    flow: ["CRM", "O.N.E.Tech Intelligence", "Policy Engine", "WhatsApp", "CRM"],
    timeline: [
      { t: "16:02:11", text: "Withdrawal support event received — $8,400 pending 52h", system: "CRM", phase: "event" },
      { t: "16:02:11", text: "Client classified: Withdrawal Journey — Sensitive", system: "O.N.E.Tech", phase: "state" },
      { t: "16:02:12", text: "Policy check: WD-01 non-interference enforced — status-only communication permitted", system: "Policy Engine", phase: "policy" },
      { t: "16:02:12", text: "Decision: human escalation + approved status update — priority Critical", system: "O.N.E.Tech", phase: "decision" },
      { t: "16:02:13", text: "CRM task created → Senior Retention Officer (SLA 30m)", system: "CRM", phase: "action" },
      { t: "16:02:14", text: "Approved English status update sent via WhatsApp (WD-STATUS-01) — human-approved", system: "WhatsApp", phase: "action" },
      { t: "16:02:19", text: "Message delivered · opened", system: "WhatsApp", phase: "action" },
      { t: "16:03:55", text: "Client reply: 'Thank you for the update.' — sentiment recovered", system: "WhatsApp", phase: "response" },
      { t: "16:11:20", text: "Payments team released the withdrawal (human action — not O.N.E.Tech)", system: "Payment Gateway", phase: "response" },
      { t: "16:11:21", text: "Lifecycle updated: Withdrawal Support Event → Withdrawal Completed · CRM write-back", system: "CRM", phase: "update" },
      { t: "16:11:21", text: "Outcome recorded: client retained — no revenue attribution on withdrawal cases", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "withdrawal-pt", category: "Withdrawal",
    boardFrom: "Withdrawal Processing", boardTo: "Withdrawal Processing",
    client: { name: "Carlos Mendes", ref: "SIM-2210", country: "Portugal", language: "Portuguese", jurisdiction: "EU entity — CySEC", value: "€7,500 request", segment: "Standard retail" },
    condition: { label: "Withdrawal Support Event", severity: "Low", timeInState: "Processing normally" },
    attribution: "Excluded",
    metric: null,
    policyBoundary: WD_BOUNDARY,
    event: { t: "15:44:27", type: "Withdrawal Status Request", source: "CRM", amount: "€7,500 processing" },
    stateTransition: { from: "Withdrawal Processing", to: "Withdrawal Support Event" },
    classification: "WITHDRAWAL SUPPORT EVENT",
    why: [
      "Withdrawal of €7,500 in normal processing",
      "Client requested a status update",
      "No delay or escalation signal",
      "WD-01 non-interference active — status communication only",
    ],
    policy: { blocked: false, checks: [
      "Client communication consent",
      "Entity rules passed (EU book)",
      "Approved status-only template available (WD-STATUS-02)",
      "WD-01 non-interference: no influence on the withdrawal itself",
      "Human task available if additional support is required",
    ] },
    decision: {
      type: "APPROVED STATUS COMMUNICATION", workflow: "Withdrawal Status Update", priority: "Medium", confidence: "99%",
      reason: "Client asked for status; only broker-approved status communication is permitted",
      channel: "Email", language: "Portuguese",
    },
    action: {
      kind: "automated", channel: "Email", language: "Portuguese", template: "WD-STATUS-02 (status-only)", t: "15:44:29",
      message: "(PT) Olá Carlos — o seu pedido de levantamento de €7.500 está atualmente em processamento. Não é necessária qualquer ação da sua parte. Se precisar de apoio adicional, a nossa equipa está disponível: [support-link]. (Simulated message — synthetic data)",
      delivery: ["Sent", "Delivered", "Opened"],
    },
    response: [
      { t: "15:46:10", text: "Client acknowledged — no further contact needed", system: "Email", phase: "response" },
    ],
    stateFinal: { from: "Withdrawal Support Event", to: "Withdrawal Processing" },
    outcome: {
      title: "Status Notification Sent", value: "—", intervention: "Approved Portuguese status update",
      language: "Portuguese", time: "1m 43s", classification: "EXCLUDED — WITHDRAWAL",
      crm: "Updated", attribution: "Excluded — no revenue recovery attribution on withdrawal cases",
    },
    flow: ["CRM", "O.N.E.Tech Intelligence", "Policy Engine", "Email", "CRM"],
    timeline: [
      { t: "15:44:27", text: "Withdrawal status request received — €7,500 processing", system: "CRM", phase: "event" },
      { t: "15:44:28", text: "Client classified: Withdrawal Support Event", system: "O.N.E.Tech", phase: "state" },
      { t: "15:44:28", text: "Policy check: WD-01 — status-only communication permitted", system: "Policy Engine", phase: "policy" },
      { t: "15:44:29", text: "Decision: Approved Status Communication — priority Medium", system: "O.N.E.Tech", phase: "decision" },
      { t: "15:44:29", text: "Portuguese status update sent (WD-STATUS-02)", system: "Email", phase: "action" },
      { t: "15:44:34", text: "Message delivered · opened", system: "Email", phase: "action" },
      { t: "15:46:10", text: "Client acknowledged — no further contact needed", system: "Email", phase: "response" },
      { t: "15:46:11", text: "State unchanged: Withdrawal Processing · CRM note added", system: "CRM", phase: "update" },
      { t: "15:46:11", text: "Outcome recorded: Excluded — no revenue attribution on withdrawal cases", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "multilingual", category: "FTD",
    boardFrom: "Registered — No FTD", boardTo: "Onboarding Engaged",
    client: { name: "Layla Haddad", ref: "SIM-2211", country: "Jordan", language: "Arabic", jurisdiction: "International entity", value: "—", segment: "New retail" },
    condition: { label: "FTD Opportunity", severity: "Medium", timeInState: "2 hours" },
    attribution: "Assisted",
    metric: null,
    event: { t: "12:08:19", type: "Registration Completed — No FTD", source: "CRM", amount: null },
    stateTransition: { from: "Registered", to: "Registered — No FTD" },
    classification: "FTD OPPORTUNITY",
    why: [
      "Recently registered — no FTD",
      "Channel permissions: WhatsApp ✓ · Email ✓ · SMS ✕",
      "Profile language: Arabic",
      "Funding window active",
    ],
    policy: { blocked: false, checks: [
      "Communication permitted",
      "Channel permission matrix applied",
      "Frequency cap clear",
      "Entity rules passed",
      "Approved Arabic template available (ONB-AR-01)",
      "Language on approved list: Arabic",
    ] },
    decision: {
      type: "AUTOMATED ONBOARDING", workflow: "Multilingual Onboarding", priority: "Medium", confidence: "88%",
      reason: "Channel selected from the permission matrix; language selected from the client profile",
      channel: "WhatsApp", language: "Arabic",
    },
    action: {
      kind: "automated", channel: "WhatsApp", language: "Arabic", template: "ONB-AR-01", t: "12:08:21",
      channelOptions: [
        { channel: "WhatsApp", allowed: true, selected: true },
        { channel: "Email", allowed: true, selected: false },
        { channel: "SMS", allowed: false, selected: false },
      ],
      message: "(AR) مرحباً ليلى — حسابك جاهز الآن. عندما تكونين مستعدة، يمكنك إتمام أول إيداع خلال دقيقتين من هنا: [funding-link]. فريقنا متاح باللغة العربية في أي وقت. (Simulated message — synthetic data)",
      delivery: ["Sent", "Delivered", "Opened"],
    },
    response: [
      { t: "12:11:02", text: "Message opened — funding link viewed", system: "WhatsApp", phase: "response" },
    ],
    stateFinal: { from: "Registered — No FTD", to: "Onboarding Engaged" },
    outcome: {
      title: "Onboarding Engaged", value: "—", intervention: "Arabic WhatsApp onboarding",
      language: "Arabic", time: "2m 43s", classification: "ASSISTED ONBOARDING",
      crm: "Updated", attribution: "Assisted — engagement followed the Arabic communication",
    },
    flow: ["CRM", "O.N.E.Tech Intelligence", "Policy Engine", "WhatsApp", "CRM"],
    timeline: [
      { t: "12:08:19", text: "Registration completed — no FTD", system: "CRM", phase: "event" },
      { t: "12:08:20", text: "Client profile read: language Arabic · permissions WhatsApp ✓ Email ✓ SMS ✕", system: "CRM", phase: "state" },
      { t: "12:08:20", text: "Policy check passed — channel permission matrix applied", system: "Policy Engine", phase: "policy" },
      { t: "12:08:21", text: "Decision: Multilingual Onboarding — WhatsApp selected, Arabic selected (template ONB-AR-01)", system: "O.N.E.Tech", phase: "decision" },
      { t: "12:08:21", text: "Arabic WhatsApp onboarding message sent", system: "WhatsApp", phase: "action" },
      { t: "12:08:26", text: "Message delivered", system: "WhatsApp", phase: "action" },
      { t: "12:11:02", text: "Message opened — funding link viewed", system: "WhatsApp", phase: "response" },
      { t: "12:11:03", text: "Lifecycle updated: Registered — No FTD → Onboarding Engaged · CRM updated", system: "CRM", phase: "update" },
      { t: "12:11:03", text: "Assisted onboarding attributed", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
  {
    id: "organic", category: "Organic",
    boardFrom: "Registered", boardTo: "Organic FTD",
    client: { name: "Thomas Evans", ref: "SIM-2212", country: "United Kingdom", language: "English", jurisdiction: "UK entity", value: "£3,000", segment: "New retail" },
    condition: { label: "FTD Opportunity — Observing", severity: "Low", timeInState: "22 minutes" },
    attribution: "Organic",
    metric: { metric: "organic" },
    event: { t: "16:40:05", type: "Registration Completed", source: "CRM", amount: null },
    stateTransition: { from: "Registered", to: "Registered — Observation Window" },
    classification: "FTD OPPORTUNITY — OBSERVING",
    why: [
      "Registration completed",
      "Configured waiting window has not expired",
      "No intervention permitted yet",
      "Client behaviour observed passively",
    ],
    policy: { blocked: false, checks: [
      "Communication permitted",
      "Client opted in",
      "Waiting window active — intervention not yet permitted",
      "Account status eligible",
    ] },
    decision: {
      type: "NO ACTION — OBSERVATION WINDOW", workflow: "Observe", priority: "—", confidence: "—",
      reason: "Configured waiting window has not expired — the client is given room to act independently",
      channel: "—", language: "—",
    },
    action: { kind: "none", noneReason: "O.N.E.Tech observes but does not intervene during the configured waiting window." },
    response: [
      { t: "17:02:41", text: "Deposit initiated — organic, no prior O.N.E.Tech communication", system: "Payment Gateway", phase: "response" },
      { t: "17:03:15", text: "£3,000 FTD confirmed", system: "Payment Gateway", phase: "response" },
    ],
    stateFinal: { from: "Registered — Observation Window", to: "Organic FTD" },
    outcome: {
      title: "Organic FTD", value: "£3,000", intervention: "None — no O.N.E.Tech communication",
      language: "—", time: "23m 10s", classification: "ORGANIC FTD",
      crm: "Updated", attribution: "Organic — NOT attributed to O.N.E.Tech; attribution model integrity preserved",
    },
    flow: ["CRM", "O.N.E.Tech Intelligence", "Policy Engine", "—", "CRM"],
    timeline: [
      { t: "16:40:05", text: "Registration completed", system: "CRM", phase: "event" },
      { t: "16:40:06", text: "State: Registered — observation window active", system: "O.N.E.Tech", phase: "state" },
      { t: "16:40:06", text: "Policy check: waiting window not expired — intervention not permitted", system: "Policy Engine", phase: "policy" },
      { t: "16:40:06", text: "Decision: NO ACTION — observation window", system: "O.N.E.Tech", phase: "decision" },
      { t: "16:40:06", text: "No action taken — client observed passively", system: "O.N.E.Tech", phase: "action" },
      { t: "17:02:41", text: "Deposit initiated — organic, no prior O.N.E.Tech communication", system: "Payment Gateway", phase: "response" },
      { t: "17:03:15", text: "£3,000 FTD confirmed", system: "Payment Gateway", phase: "update" },
      { t: "17:03:16", text: "Lifecycle updated: Registered → Organic FTD · CRM updated", system: "CRM", phase: "update" },
      { t: "17:03:16", text: "Classification: ORGANIC FTD — not attributed to O.N.E.Tech", system: "O.N.E.Tech", phase: "outcome" },
    ],
  },
];
